import { z } from 'zod'

import { subscriptionTypes } from '../domain/subscription'

export const SubscriptionFormSchema = z.object({
  eventTypes: z.array(z.enum(subscriptionTypes)),
  url: z.string(),
  name: z.string(),
  description: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
})

export type SubscriptionFormSchemaType = z.infer<typeof SubscriptionFormSchema>
